import React from 'react';
import { Card, Divider, Image, Icon, Popup, Button, Label } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import _ from 'lodash';

import hasRESTClient from '../../hocs/has-rest-client';
import hasUserInfo from '../../hocs/has-user-info';
import LiveStoriesCounter from '../live-stories-counter';
import InfluencerSocialChannelsTable from '../influencer-social-channels-table';

const avatarStyle = {
  width: 170,
  height: 170,
  display: 'block',
  margin: '20px auto 0 auto',
};

const cardStyle = {
  textAlign: 'center',
  minWidth: 240,
};

const h3Style = {
  padding: '10px 0',
};


class VerticalInfluencerBar extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      loading: false,
    };
  }

  influencerRedirectNewTab = async (id, newTab) => {
    const { userInfo: { organisationId }, restClient, router } = this.props;
    const linkUrl = `influencerLink?filter[influencer]=${id}&filter[organisation]=${organisationId}`;
    const link = await restClient.get(linkUrl);
    if (link) {
      const linkId = _.get(link, 'data.data[0].id');
      if (newTab) {
        window.open(`/influencer/${linkId}/statistics`);
      } else {
        router.push(`/influencer/${linkId}/statistics`);
      }
    } else {
      console.error('Could not find influencer link.');
    }
  };

  render() {
    const {
      id,
      name,
      thumbnail,
      isLoading,
      instagramId,
      isLoadingLiveStoriesCount,
      liveStoriesCount,
      onLiveStoriesLabelClick,
      ...rest
    } = this.props;

    // the loader doesn't work if this is destructured above.
    // I guess this takes a copy or something
    const instagram = this.props.instagram;

    return (
      <Card style={cardStyle} fluid>
        <Card.Content>
          <Image
            style={avatarStyle}
            src={thumbnail}
            centered
            avatar
            className="circular"
          />
          <h3 style={h3Style}>
            {name} <Popup
              trigger={
                <Button
                  circular
                  inverted
                  color="green"
                  icon="external alternate"
                  onClick={() => { this.influencerRedirectNewTab(id, true); }}
                />
              }
              content={`Open ${name} profile in a new tab.`}
            />

            <Popup
              trigger={
                <Button
                  circular
                  inverted
                  color="pink"
                  icon="arrow alternate circle right"
                  onClick={() => { this.influencerRedirectNewTab(id, false); }}
                />
              }
              content={`Open ${name} profile.`}
            />
            <Divider fitted hidden />
            <LiveStoriesCounter
              onClick={onLiveStoriesLabelClick}
              influencerName={name}
              loading={isLoadingLiveStoriesCount}
              count={liveStoriesCount}
            /></h3>
          {
            isLoading && <Icon name="refresh" loading centered />
          }
          {
            !isLoading && instagram &&
            <div>
              <Popup
                trigger={
                  <Label><Icon name="instagram" />ID: {instagramId || 'NO INSTAGRAM ID'}</Label>
                }
                content="Instagram Account ID"
              />
            </div>
          }
          {
            !isLoading && <InfluencerSocialChannelsTable {...rest} />
          }
        </Card.Content>
      </Card>
    );
  }
}

VerticalInfluencerBar.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  thumbnail: PropTypes.string.isRequired,
  primarySocialHandle: PropTypes.string.isRequired,
  instagram: PropTypes.string.isRequired,
  instagramCount: PropTypes.number.isRequired,
  instagramAuthorised: PropTypes.bool.isRequired,
  instagramBusinessAccount: PropTypes.bool.isRequired,
  isFacebookPersonalPage: PropTypes.bool,
  facebook: PropTypes.string.isRequired,
  facebookCount: PropTypes.number.isRequired,
  facebookAuthorised: PropTypes.bool.isRequired,
  twitter: PropTypes.string.isRequired,
  twitterCount: PropTypes.number.isRequired,
  twitterAuthorised: PropTypes.bool.isRequired,
  youtubeChannelTitle: PropTypes.string.isRequired,
  youtubeCount: PropTypes.number.isRequired,
  youtubeAuthorised: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isLoadingLiveStoriesCount: PropTypes.bool.isRequired,
  liveStoriesCount: PropTypes.number.isRequired,
  onLiveStoriesLabelClick: PropTypes.func.isRequired,
};

VerticalInfluencerBar.defaultProps = {
  isFacebookPersonalPage: false,
};

export default compose(
  withRouter,
  hasRESTClient,
  hasUserInfo,
)(VerticalInfluencerBar);



/** WEBPACK FOOTER **
 ** ./src/components/vertical-influencer-bar/index.js
 **/